import React, { memo } from 'react';
import SessionsLoader from '../../../../../../core/components/campaigns/campaigndetails/sessionsTab/SessionsLoader';
import SessionsController from '../../../../../../core/components/campaigns/campaigndetails/sessionsTab/SessionsController';
import SessionsTabView from './SessionsTabVIew';

const SessionsTab = ({ ...props }) => {
  return (
    <SessionsLoader {...props}>
      <SessionsController {...props}>
        <SessionsTabView {...props} />
      </SessionsController>
    </SessionsLoader>
  );
};

export default memo(SessionsTab);
